import FlashMinus from './FlashMinus';
import IconArrowRight from './IconArrowRight';
import IconCheck from './IconCheck';
import IconClose from './IconClose';
import IconDelete from './IconDelete';
import IconMinus from './IconMinus';
import IconPlatform from './IconPlatform';
import IconPlus from './IconPlus';
import IconTime from './IconTime';

export {
  FlashMinus,
  IconArrowRight,
  IconCheck,
  IconClose,
  IconDelete,
  IconMinus,
  IconPlatform,
  IconPlus,
  IconTime,
};



// WEBPACK FOOTER //
// ./src/icons/index.js